import { useId } from 'react';

import Icon from 'ms-ui-primitives/Icon';

import type { Props } from '../types';

const PlusThin = ({
  color,
  size,
  title,
  titleId,
  aphroditeStyles = [],
}: Props) => {
  const mask1Id = useId();
  const mask2Id = useId();

  return (
    <Icon
      color={color}
      size={size}
      aphroditeStyles={aphroditeStyles}
      title={title}
      titleId={titleId}
      viewBoxWidth={24}
      viewBoxHeight={24}
    >
      <mask
        id={mask2Id}
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="5"
        y="5"
        width="15"
        height="14"
      >
        <mask
          id={mask1Id}
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="25"
          height="24"
        >
          <path fill="#D9D9D9" d="M.5 0h24v24H.5z" />
        </mask>
        <g mask={`url(#${mask1Id})`}>
          <path
            d="M11.5 13h-5a.967.967 0 0 1-.713-.287A.968.968 0 0 1 5.5 12c0-.283.096-.52.287-.713A.967.967 0 0 1 6.5 11h5V6c0-.283.096-.52.287-.713A.968.968 0 0 1 12.5 5c.283 0 .52.096.713.287.191.192.287.43.287.713v5h5c.283 0 .52.096.712.287.192.192.288.43.288.713s-.096.52-.288.713A.968.968 0 0 1 18.5 13h-5v5c0 .283-.096.52-.287.712A.968.968 0 0 1 12.5 19a.968.968 0 0 1-.713-.288A.968.968 0 0 1 11.5 18v-5Z"
            fill="#1C1B1F"
          />
        </g>
      </mask>
      <g mask={`url(#${mask2Id})`}>
        <path d="M.5 0h24v24H.5z" />
      </g>
    </Icon>
  );
};

PlusThin.displayName = 'PlusThin';

export default PlusThin;
